import axios from 'axios';

export default axios.create({
 //baseURL: 'https://teste.toolsgestormob.com.br:8443/rest'   
//  baseURL: 'http://LOCALHOST:8080/rest'
baseURL: 'https://toolsgestormob.com.br:8443/rest'   
});
